import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useBookingConfirmation } from './hooks/BookingConfirmation.hook';
import BookingConfirmationView from './views/BookingConfirmationView';
import LoadingComponent from '@/components/general/Loading/LoadingComponent';

const BookingConfirmationController = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const transactionId = searchParams.get('transaction_id');

  const languageFromPath = searchParams.get('lang');
  const { loading, error, reservation } = useBookingConfirmation(transactionId);

  const languageData = useSelector((state) => state.lenguage?.lang);

  const initialValues = {
    email: '',
    password: '',
  };

  useEffect(() => {
    if (error) {
      console.log('❌ Error al cargar la reserva:', error);
    }
  }, [error]);

  if (loading) {
    return <LoadingComponent loading={loading} />;
  } else {
    return (
      <BookingConfirmationView
        initialValues={initialValues}
        languageData={languageData}
        reservation={reservation}
        languageFromPath={languageFromPath}
      />
    );
  }
};

export default BookingConfirmationController;
